"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOCXSentenceChildrenRun = exports.HTMLSentenceChildrenRun = exports.HTMLSentenceChildrenRunCSS = void 0;
const react_1 = __importDefault(require("react"));
const std = __importStar(require("../../law/std"));
const util_1 = require("../../util");
const html_1 = require("../common/html");
const component_1 = require("../common/docx/component");
const tags_1 = require("../common/docx/tags");
const arithFormulaRun_1 = require("./arithFormulaRun");
const quoteStructRun_1 = require("./quoteStructRun");
const controlRun_1 = require("./controlRun");
const common_1 = require("../common");
exports.HTMLSentenceChildrenRunCSS = `
`;
exports.HTMLSentenceChildrenRun = (0, html_1.wrapHTMLComponent)("HTMLSentenceChildrenRun", ((props) => {
    const { els, htmlOptions } = props;
    const { renderControlEL } = htmlOptions;
    const runs = [];
    for (const el of els) {
        if (typeof el === "string") {
            runs.push(el);
        }
        else if (el.isControl) {
            if (renderControlEL) {
                runs.push(react_1.default.createElement(controlRun_1.HTMLControlRun, { el: el, ...props }));
            }
            else {
                runs.push(el.text());
            }
        }
        else {
            if (el.tag === "Ruby") {
                const rb = el.children
                    .map(c => (typeof c === "string")
                    ? c
                    : !std.isRt(c)
                        ? c.text()
                        : "").join("");
                const rt = el.children
                    .filter(c => !(typeof c === "string") && std.isRt(c))
                    .map(c => c.text())
                    .join("");
                runs.push(react_1.default.createElement("ruby", { ...(0, html_1.elProps)(el, htmlOptions) },
                    rb,
                    react_1.default.createElement("rt", null, rt)));
            }
            else if (el.tag === "Sub") {
                runs.push(react_1.default.createElement("sub", { ...(0, html_1.elProps)(el, htmlOptions) }, el.text()));
            }
            else if (el.tag === "Sup") {
                runs.push(react_1.default.createElement("sup", { ...(0, html_1.elProps)(el, htmlOptions) }, el.text()));
            }
            else if (el.tag === "QuoteStruct") {
                runs.push(react_1.default.createElement(quoteStructRun_1.HTMLQuoteStructRun, { el: el, htmlOptions }));
            }
            else if (el.tag === "ArithFormula") {
                runs.push(react_1.default.createElement(arithFormulaRun_1.HTMLArithFormulaRun, { el: el, htmlOptions }));
            }
            else if (el.tag === "Line") {
                return ((react_1.default.createElement("span", { className: "line", ...(0, html_1.elProps)(el, htmlOptions) },
                    react_1.default.createElement(exports.HTMLSentenceChildrenRun, { els: el.children, htmlOptions }))));
            }
            else {
                (0, util_1.assertNever)(el);
            }
        }
    }
    return react_1.default.createElement(react_1.default.Fragment, null, (0, common_1.withKey)(runs));
}));
exports.DOCXSentenceChildrenRun = (0, component_1.wrapDOCXComponent)("DOCXSentenceChildrenRun", ((props) => {
    const { els, emphasis, docxOptions } = props;
    const runs = [];
    for (const el of els) {
        if (typeof el === "string" || el instanceof String) {
            runs.push(react_1.default.createElement(tags_1.w.r, null,
                emphasis ? react_1.default.createElement(tags_1.w.rStyle, { "w:val": "Emphasis" }) : null,
                react_1.default.createElement(tags_1.w.t, null, el)));
        }
        else if (el.isControl) {
            runs.push(react_1.default.createElement(tags_1.w.r, null,
                emphasis ? react_1.default.createElement(tags_1.w.rStyle, { "w:val": "Emphasis" }) : null,
                react_1.default.createElement(tags_1.w.t, null, el.text())));
        }
        else {
            if (el.tag === "Ruby") {
                const rb = el.children
                    .map(c => (typeof c === "string")
                    ? c
                    : !std.isRt(c)
                        ? c.text()
                        : "").join("");
                const rt = el.children
                    .filter(c => !(typeof c === "string") && std.isRt(c))
                    .map(c => c.text())
                    .join("");
                runs.push(react_1.default.createElement(tags_1.w.r, null,
                    emphasis ? react_1.default.createElement(tags_1.w.rStyle, { "w:val": "Emphasis" }) : null,
                    react_1.default.createElement(tags_1.w.ruby, null,
                        react_1.default.createElement(tags_1.w.rt, null,
                            react_1.default.createElement(tags_1.w.r, null,
                                react_1.default.createElement(tags_1.w.t, null, rt))),
                        react_1.default.createElement(tags_1.w.rubyBase, null,
                            react_1.default.createElement(tags_1.w.r, null,
                                react_1.default.createElement(tags_1.w.t, null, rb))))));
            }
            else if (el.tag === "Sub") {
                runs.push(react_1.default.createElement(tags_1.w.r, null,
                    react_1.default.createElement(tags_1.w.rPr, null,
                        react_1.default.createElement(tags_1.w.vertAlign, { "w:val": "subscript" })),
                    react_1.default.createElement(tags_1.w.t, null, el.text())));
            }
            else if (el.tag === "Sup") {
                runs.push(react_1.default.createElement(tags_1.w.r, null,
                    react_1.default.createElement(tags_1.w.rPr, null,
                        react_1.default.createElement(tags_1.w.vertAlign, { "w:val": "superscript" })),
                    react_1.default.createElement(tags_1.w.t, null, el.text())));
            }
            else if (el.tag === "QuoteStruct") {
                runs.push(react_1.default.createElement(quoteStructRun_1.DOCXQuoteStructRun, { el: el, docxOptions }));
            }
            else if (el.tag === "ArithFormula") {
                runs.push(react_1.default.createElement(arithFormulaRun_1.DOCXArithFormulaRun, { el: el, docxOptions }));
            }
            else if (el.tag === "Line") {
                runs.push(react_1.default.createElement(exports.DOCXSentenceChildrenRun, { els: el.children, docxOptions }));
            }
            else {
                (0, util_1.assertNever)(el);
            }
        }
    }
    return react_1.default.createElement(react_1.default.Fragment, null, (0, common_1.withKey)(runs));
}));
//# sourceMappingURL=sentenceChildrenRun.js.map